import { render } from "./CollectionDetailsContainer.vue?vue&type=template&id=2b694730&scoped=true"
import script from "./CollectionDetailsContainer.vue?vue&type=script&lang=js"
export * from "./CollectionDetailsContainer.vue?vue&type=script&lang=js"

import "./CollectionDetailsContainer.vue?vue&type=style&index=0&id=2b694730&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b694730"]])

export default __exports__